module.exports = __webpack_public_path__ + "DINNextLTPro-Regular.eot?50d477fcc396446bfcfd1be02b79b15c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Regular.eot
// module id = 302
// module chunks = 0